<script setup lang="ts">
import type { ExplainerRelation } from "~/types/article"

defineProps<{ note: ExplainerRelation }>()
</script>

<template>
  <USidenote :note="note" title-class="text-red-darker" />
</template>
